import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

import { Icon } from '../../Atoms/Icon';

import ButtonDelete from './ButtonDelete';

const TextSearchField = ({
  value = '',
  onSubmit,
  onKeyDown,
  onChange,
  onReset,
  className,
  placeholder = 'Search',
  includeForm = true,
  disabled = false,
  ...props
}) => {
  const buttonClassName = 'h-100 py-0 d-flex align-items-center px-2';
  const formButtonClassName = classNames(
    'position-absolute right-0 top-0',
    buttonClassName,
  );

  return includeForm ? (
    <Form onSubmit={onSubmit} className="position-relative">
      <Form.Control
        data-testid="terminal-search-input"
        placeholder={placeholder}
        value={value}
        onKeyDown={onKeyDown}
        onChange={onChange}
        disabled={disabled}
        className={classNames('pr-5 text-truncate', className)}
        {...props}
      />

      {value ? (
        <ButtonDelete
          onClick={onReset}
          disabled={disabled}
          className={formButtonClassName}
        />
      ) : (
        <Button
          variant="link"
          disabled
          className={classNames(formButtonClassName, 'text-muted')}
          style={{ opacity: 1 }}
        >
          <Icon name="search" />
        </Button>
      )}
    </Form>
  ) : (
    <InputGroup>
      <Form.Control
        data-testid="terminal-search-input"
        placeholder={placeholder}
        value={value}
        onKeyDown={onKeyDown}
        onChange={onChange}
        className={classNames('pr-5 text-truncate border-right-0', className)}
        {...props}
      />
      <InputGroup.Append>
        {value ? (
          <ButtonDelete
            onClick={onReset}
            disabled={disabled}
            className={buttonClassName}
            style={{ opacity: 1 }}
          />
        ) : (
          <Button
            variant="link"
            disabled
            className={classNames(buttonClassName, 'text-muted')}
            style={{ opacity: 1 }}
          >
            <Icon name="search" />
          </Button>
        )}{' '}
      </InputGroup.Append>
    </InputGroup>
  );
};

TextSearchField.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  className: PropTypes.string,
  includeForm: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default TextSearchField;
